import { FaInfoCircle } from "react-icons/fa";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import { CardInformative } from "@/pages/esus/ReterritorializationAcsDashboard/CardInformative";
import { CardOverlayTrigger } from "@/components/CardOverlayTrigger";

import { RiskClassification } from "@/@types/sintegrada/RiskClassification";
import { ResumeGrouped } from "@/services/esus/attendanceService";

type RiskClassificationTimeData = ResumeGrouped<RiskClassification | null, object>;

type Props = {
	totalAttendances: number;
	totalMedicalAttendancesRequested: number;
	totalMedicalAttendancesEvaluated: number;
	evasions: number;
	totalAverageWaitTime: number;
	minWaitTime: number;
	maxWaitTime: number;
	totalAverageTime: number;
	minTime: number;
	maxTime: number;
	totalAverageMedicalAttendancesPerDay: number;
	averageWaitTimeInSecondsByRiskClassification: RiskClassificationTimeData[];
};

export function SpecialtyOfficeDashboardCards({
	totalAttendances,
	totalMedicalAttendancesRequested,
	totalMedicalAttendancesEvaluated,
	evasions,
}: Props) {
	return (
		<Row className=" py-2 bg-white justify-content-evenly rounded">
			<Col sm={12} md={3} lg={3} xxl={3} className="my-2">
				<CardInformative
					title="Total de atendimentos médicos"
					value={totalAttendances.toLocaleString()}
					classNameCard="bg-primary rounded p-2 m-2 bg-white h-100"
					classNameTitle="text-white text-center"
					classNameValue="text-white"
					metaData={
						<CardOverlayTrigger
							header=""
							message=""
							icon={<FaInfoCircle className="text-white" />}
						/>
					}
				/>
			</Col>
			<Col sm={12} md={3} lg={3} xxl={3} className="my-2">
				<CardInformative
					title="Atendimento médico"
					value={totalMedicalAttendancesRequested.toLocaleString()}
					classNameCard="border border-muted rounded p-2 m-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					metaData={
						<CardOverlayTrigger
							header=""
							message=""
							icon={<FaInfoCircle className="text-muted" />}
						/>
					}
				/>
			</Col>
			<Col sm={12} md={3} lg={3} xxl={3} className="my-2">
				<CardInformative
					title="Reavaliação"
					value={totalMedicalAttendancesEvaluated.toLocaleString()}
					classNameCard="border border-muted rounded p-2 m-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					metaData={
						<CardOverlayTrigger
							header=""
							message=""
							icon={<FaInfoCircle className="text-muted" />}
						/>
					}
				/>
			</Col>
			<Col sm={12} md={3} lg={3} xxl={3} className="my-2">
				<CardInformative
					title="Total de evasões"
					value={evasions.toLocaleString()}
					classNameCard="border border-muted rounded p-2 m-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					metaData={
						<CardOverlayTrigger
							header=""
							message=""
							icon={<FaInfoCircle className="text-muted" />}
						/>
					}
				/>
			</Col>
		</Row>
	);
}
